import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";
import {useParams} from "react-router-dom";
import ImageGallery from "react-image-gallery";

export default () => {
    let title = "Рестораны, бары Restaurants, bars";

    const itemsData = [
        {
            id: 1,
            location: 'Брест',
            name: 'Ресторан «Буг» ОАО «Буг-сервис»',
            adress: '224030 г. Брест, ул. Ленина, 2',
            countItem: 'Число мест: 80',
            timeWork: 'время работы - с 8.00 до 23.00',
            phones: [
                '(+375) 162 23-64-10',
                '(+375) 162 23-64-17',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/bug550.jpg'),
                    alt: 'Ресторан «Буг»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: №52 от 28.11.97 г.',
                'Располагается на 1-м этаже гостиницы «Буг». Открыт в 1958 г. Торговая площадь свыше 140 м2.',
                'Обслуживание презентаций, приемов, торжеств.',
                'Услуги общественного питания в номерах гостиниц.',
                'Комплектация дорожных наборов.',
                'Принадлежность предприятия: Открытое акционерное общество «БУГ-СЕРВИС»',
            ],
        },
        {
            id: 2,
            location: 'Брест',
            name: 'Ресторан «Москва» ОАО «Москва»',
            adress: 'г. Брест, пр. Машерова, 17',
            countItem: 'Число мест: 186 и 80',
            timeWork: 'Время работы - с 9.00 до 02.00',
            phones: [
                '(+375) 162 20-43-23',
                '(+375) 162 20-10-93',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/mos550.jpg'),
                    alt: 'Ресторан «Москва»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Ресторан русской и белорусской кухни.',
                'Открыт в 1977 в составе торгово-бытового центра по улице Московской. Торговая площадь 620 м2.',
                'Имеет 2 зала, 2 бара; летом действует открытая площадка на 3-м этаже. Одновременно может обслужить около 300 человек. Предлагает богатый выбор блюд русской кухни и фирменных блюд. В оформлении интерьеров использованы мозаика, декоративные решётки, дерево.',
                'Обслуживание торжеств, приемов, юбилеев, семейных обедов и ужинов. Обеды в дорогу и на дом, оказание услуг по организации торжеств на дому, стол заказов на изготовление кулинарных и кондитерских изделий в обычном и банкетном исполнении.',
                'Обслуживание посетителей, торжеств, приемов, юбилеев, семейных обедов и ужинов.',
                'Обеды в дорогу и на дом.',
                'Организация торжеств на дому.',
                'Стол заказов на кулинарные и кондитерские изделия в обычном и банкетном исполнении.',
                'Принадлежность предприятия: Открытое акционерное общество «МОСКВА»',
            ],
        },
        {
            id: 3,
            location: 'Брест',
            name: 'Винный бар ресторана «Москва» ОАО «Москва»',
            adress: 'г. Брест, пр. Машерова, 17',
            countItem: 'Число мест: 37',
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: Открытое акционерное общество «МОСКВА»',
            ],
        },
        {
            id: 4,
            location: 'Брест',
            name: 'Ресторан ст. Брест-Центральный ТПР ДУП «Желдорсервис»',
            adress: 'вокзал станции Брест-Центральный',
            countItem: 'Число мест: 100',
            timeWork: 'время работы - с 10.00 до 22.00',
            phones: [
                '(+375) 162 27-24-82',
                '(+375) 162 27-23-43',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/zd550.jpg'),
                    alt: 'Ресторан ст. Брест-Центральный',
                }
            ],
            desc: [
                'Категория: высшая. Присвоение категории: МТ РБ № 20 от 22.01.2004г.',
                'Обслуживание посетителей, организаций, торжественных мероприятий, банкетов.',
                'Изготовление мясных и кулинарных полуфабрикатов.',
                'Тематическое оформление блюд к юбилеям и торжествам.',
                'Принадлежность предприятия: Торгово-производственное республиканское дочернее унитарное предприятие «ЖЕЛДОРСЕРВИС» Брестского отделения Белорусской железной дороги (ТПР ДУП «ЖЕЛДОРСЕРВИС»)',
            ],
        },
        {
            id: 5,
            location: 'Брест',
            name: 'Бар № 2 в здании вокзала «Брест-Центральный',
            adress: 'Центральный зал ожидания вокзала ст. Брест -Центральный',
            countItem: 'Число мест: 20',
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: Торгово-производственное республиканское дочернее унитарное предприятие «ЖЕЛДОРСЕРВИС» Брестского отделения Белорусской железной дороги (ТПР ДУП «ЖЕЛДОРСЕРВИС»)',
            ],
        },
        {
            id: 6,
            location: 'Брест',
            name: 'Вагоны-рестораны ресторана ст. Брест №№ 63332, 63191, 63340, 63357, 63381, 63316, 63175, 63183',
            adress: 'Вагоны поездов Брест-Москва, Брест- С. Петербург Брест-Новосибирск',
            countItem: 'Число мест: 48',
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: Торгово-производственное республиканское дочернее унитарное предприятие «ЖЕЛДОРСЕРВИС» Брестского отделения Белорусской железной дороги (ТПР ДУП «ЖЕЛДОРСЕРВИС»)',
            ],
        },
        {
            id: 7,
            location: 'Брест',
            name: 'Купе-буфеты ресторана станции ст. Брест №№ 11537, 17684, 16108',
            adress: 'Купе-буфеты поезда Брест-Минск',
            countItem: 'Число мест: 14',
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: Торгово-производственное республиканское дочернее унитарное предприятие «ЖЕЛДОРСЕРВИС» Брестского отделения Белорусской железной дороги (ТПР ДУП «ЖЕЛДОРСЕРВИС»)',
            ],
        },
        {
            id: 8,
            location: 'Брест',
            name: 'Ресторан «Беларусь» ТЭУП «Бресттурист»',
            adress: 'г. Брест, б-р Шевченко, 6',
            phones: [
                '(+375) 162 20-26-90',
                '(+375) 162 22-15-54',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/bel550.jpg'),
                    alt: 'Ресторан «Беларусь»',
                }
            ],
            desc: [
                'Построен в составе гостиницы «БЕЛАРУСЬ» в 1971 г. (архитектор 3. Левченко) у западного въезда в город.',
                'Кухня белорусская, европейская. Большой выбор фирменных белорусских блюд. В вечернее время - живая музыка, фольклорный ансамбль. Для подачи фирменных и белорусских блюд предусмотрена керамическая посуда, изделия из лозы, соломки, скатерти и салфетки с белорусским орнаментом, форма официантов - с элементами белорусской символики, рушники и т.д.',
                'Проведение всех видов торжеств, фуршетов.',
                'Обслуживание клиентов ресторана в гостиничном номере.',
                'Продление времени обслуживания мероприятий сверх установленного времени, продление рабочего времени музыкального ансамбля.',
                'Выездное обслуживание, в стоимость проживания в гостинице включен завтрак.',
                'Предусмотрено диетическое и вегетарианское питание.',
                'Услуги повара, официанта.',
                'Изготовление кулинарных и кондитерских изделий в банкетном исполнении. Предоставление значительных скидок при обслуживании детей, спортсменов, туристических групп, ветеранов войны, инвалидов.',
                'Доставка пищи на рабочие места, на дом заказчику, прием предварительных заказов на комплектацию наборов в дорогу.',
                'Организация концертных программ, дискотек.',
                'Вызов такси по заказу клиента.',
            ],
        },
        {
            id: 9,
            location: 'Брест',
            name: 'Бар в гостинице «Беларусь» ТЭУП «Бресттурист»',
            adress: 'г. Брест, б-р Шевченко, 6',
            countItem: 'Число мест: 30',
            desc: [
                'Категория: первая Присвоение категории:№47 от 20.10.93г.',
                'Принадлежность предприятия: Туристско-экскурсионное унитарное предприятие «БРЕСТТУРИСТ» Туристско-экскурсионного унитарного предприятия «Беларустурист» Федерации профсоюзов Белорусской',
            ],
        },
        {
            id: 10,
            location: 'Брест',
            name: 'Ресторан «Интурист»',
            adress: 'г. Брест, пр-т Машерова,15 гостиница «Интурист»',
            countItem: 'Число мест: 200',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/in.jpg'),
                    alt: 'Ресторан «Интурист»',
                }
            ],
            desc: [
                'Категория: высшая. Присвоение категории: МТ РБ №56 от 13.03.2004г.',
                'Открыт в 1975 при одноимённой гостинице. Торговая площадь 870 м2. Имеет 2 зала (в том числе банкетный), 2 бара, кафе-экспресс, столовую.',
                'Оснащён современным тепловым, механическим, холодильным и торгово-технологическим оборудованием. Залы и бары отделаны мрамором, гранитом, искусств, кожей, художественным паркетом, бронзовыми светильниками, витражами.',
                'Принадлежность предприятия: ОАО «Туристический комплекс «Брест-Интурист»',
            ],
        },
        {
            id: 11,
            location: 'Брест',
            name: 'Бар «Вечерний»',
            adress: 'г. Брест, пр-т Машерова,15 гостиница «Интурист»',
            countItem: 'Число мест: 12',
            desc: [
                'Категория: высшая. Присвоение категории: МТ РБ №56 от 13.03.2004г.',
                'Принадлежность предприятия: ОАО «Туристический комплекс «Брест-Интурист»',
            ],
        },
        {
            id: 12,
            location: 'Брест',
            name: 'Кафе «Цветочный -экспресс»',
            adress: 'г. Брест, пр-т Машерова,15 гостиница «Интурист»',
            countItem: 'Число мест: 48',
            desc: [
                'Категория: высшая. Присвоение категории: МТ РБ №56 от 13.03.2004г.',
                'Принадлежность предприятия: ОАО «Туристический комплекс «Брест-Интурист»',
            ],
        },
        {
            id: 13,
            location: 'Брест',
            name: 'Кафе «Цитадель» КУПП «Комбинат общественного питания',
            adress: 'г. Брест, Брестская крепость-герой',
            timeWork: 'время работы - с 10.00 до 22.00',
            phones: [
                '(+375) 162 20-11-55',
                '(+375) 162 22-15-54',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/citad.jpg'),
                    alt: 'Кафе «Цитадель»',
                }
            ],
            desc: [
                'Отпуск и реализация продукции собственного производства, в т. ч. блюд белорусской кухни.',
                'Упаковка продукции после обслуживания торжеств, услуги официанта по вызову на дом, услуги повара по вызову на дом, прокат столового белья, столовой посуды и приборов.',
                'Принадлежность предприятия: Коммунальное унитарное производственно-торговое предприятие «Комбинат общественного питания»',
            ],
        },
        {
            id: 14,
            location: 'Брест',
            name: 'Кафе «Восток» КУТПП «Восток»',
            adress: 'г. Брест, Партизанский пр-т, 13',
            countItem: 'Число мест: 120',
            timeWork: 'время работы - с 13.00 до 01.00',
            phones: [
                '(+375) 162 42-95-03',
                '(+375) 162 42-95-14',
            ],
            desc: [
                'Категория: первая. Присвоение категории: №32 от 16.03.87г.',
                'Кафе «Восток» расположено в жилом микрорайоне «Восток» вблизи автотрассы. Открыто в 1984 г. Высокое качество приготовления пищи, доброжелательность коллектива, оригинальность оформления кондитерских изделий «нашли» своего покупателя.',
                'Реализация блюд белорусской и европейской кухни, кондитерских изделий.',
                'Изготовление кондитерских изделий под заказ.',
                'Приготовление блюд из продуктов заказчика.',
                'Обслуживание торжественных и других мероприятий.',
                'Вызов такси.',
                'Принадлежность предприятия: Коммунальное унитарное торгово-производственное предприятие «Восток»',
            ],
        },
        {
            id: 15,
            location: 'Брест',
            name: 'Бар «Молодежный» ОАО «Буг-сервис»',
            adress: 'г. Брест, ул. Комсомольская, 6',
            timeWork: 'время работы - с 12.00 до 23.30',
            phones: [
                '(+375) 162 26-45-31',
                '(+375) 162 26-45-31',
            ],
            desc: [
                'Обслуживание банкетов, завтраков, обедов, ужинов в номерах гостиниц, в сауне.',
                'Комплектация дорожных наборов.',
                'Принадлежность предприятия: Открытое акционерное общество «БУГ-СЕРВИС»',
            ],
        },
        {
            id: 16,
            location: 'Брест',
            name: 'Диско-бар «Планета Рок» ИУЧТП «Файв Старс»',
            adress: 'г. Брест, ул. Пионерская, 48',
            countItem: 'Число мест: 270',
            phones: [
                '(+375) 162 46-64-83',
                '(+375) 162 46-64-83',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/plr550.jpg'),
                    alt: 'Диско-бар «Планета Рок»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: №21 от 10.04.98г.',
                'Торгово- производственная деятельность.',
                'Принадлежность предприятия: Иностранное унитарное частное торговое предприятие «ФАЙВ СТАРС»',
            ],
        },
        {
            id: 17,
            location: 'Брест',
            name: 'Кафе «Веста»',
            adress: 'г. Брест, ул. Крупской, 16, гостиница «Веста»',
            countItem: 'Число мест: 60',
            timeWork: 'время работы - с 8.00 до 23.00 перерыв с 15.30-17.00',
            phones: [
                '(+375) 162 23-78-35',
                '(+375) 162 23-78-39',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/wst550.jpg'),
                    alt: 'Кафе «Веста»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: № 48 от 14.09.01 г.',
                'Общественное питание.',
                'Принадлежность предприятия: Коммунальное унитарное предприятие «ГОСТИНИЦА «ВЕСТА»',
            ],
        },
        {
            id: 18,
            location: 'Брест',
            name: 'ПБО «Бистро» ОДО «Интербизнесцентр»',
            adress: 'г. Брест, ул. Советская, 50',
            timeWork: 'время работы - с 8.00 до 22.00',
            phones: [
                '(+375) 162 23-05-50',
                '(+375) 162 23-14-94',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/vzb550.jpg'),
                    alt: 'ПБО «Бистро»',
                }
            ],
            desc: [
                'Предприятие быстрого питания 2-й наценочной категории на 10 посадочных мест.',
                'Принадлежность предприятия: Общество с дополнительной ответственностью «ИНТЕРБИЗНЕСЦЕНТР»',
            ],
        },
        {
            id: 19,
            location: 'Брест',
            name: 'Бар «Визит» ОДО «Интербизнесцентр»',
            adress: 'г. Брест, ул. Советская, 50',
            timeWork: 'время работы - с 11.00 до 23.00',
            phones: [
                '(+375) 162 23-14-94',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/viz550.jpg'),
                    alt: 'Бар «Визит»',
                }
            ],
            desc: [
                'Предприятие общественного питания 2-й наценочной категории на 90 посадочных мест.',
                'Принадлежность предприятия: Общество с дополнительной ответственностью «ИНТЕРБИЗНЕСЦЕНТР»',
            ],
        },
        {
            id: 20,
            location: 'Брест',
            name: 'Ресторан «Трактир на Ковельской»',
            adress: 'г. Брест, ул. Ковельская, 36',
            url: 'http://www.traktir-na-kovelskoi.relax.by/',
            timeWork: 'время работы - с 11.00 до 24.00',
            phones: [
                '(+375) 162 28-04-79',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/traktir.jpg'),
                    alt: 'Ресторан «Трактир на Ковельской»',
                }
            ],
            desc: [
                'Организация общественного питания, обслуживания семейных вечеров, свадеб, юбилеев и других торжественных мероприятий.',
                'Ресторан «Трактир на Ковельской» открытого акционерного общества «Брест-сервис», второй наценочной категории по уровню обслуживания, на 100 посадочных мест (2 зала), предназначен для организации питания и отдыха клиентов с предоставлением им широкого ассортимента блюд.',
                'Буквально в 400 м от границы Беларуси и Евросоюза расположен один из лучших ресторанов города «Трактир на Ковельской». Благодаря такому расположению, «Трактир на Ковельской» стал местом встречи зарубежных делегаций и дипломатов многих стран.',
                'В дизайне залов ресторана воплощена история стародавнего Бреста с оригинальными находками и решениями, придающими «Трактиру на Ковельской» особый уют.',
                'Принадлежность предприятия: Открытое акционерное общество «БРЕСТ-СЕРВИС»',
            ],
        },
        {
            id: 21,
            location: 'Брест',
            name: 'Диско-бар «Везувий» ООО «Сладкий мир»',
            adress: 'г. Брест, ул. Суворова, 108',
            timeWork: 'время работы - с 20.00 до 06.00',
            phones: [
                '(+375) 162 43-36-61',
                '(+375) 162 43-03-80',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/vez.jpg'),
                    alt: 'Диско-бар «Везувий»',
                }
            ],
            desc: [
                'Дискотека, бильярд, игровые автоматы. Торгово-закупочная деятельность.',
                'Принадлежность предприятия: Общество с ограниченной ответственностью «СЛАДКИЙ МИР»',
            ],
        },
        {
            id: 22,
            location: 'Брест',
            name: 'Ресторан «Жюль Верн» СП «Санта Импекс Брест»',
            adress: 'г. Брест, ул. Гоголя, 29',
            countItem: 'Число мест: 120',
            timeWork: 'время работы - с 12-00 до 24-00',
            phones: [
                '(+375) 162 23-67-17',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/zul.jpg'),
                    alt: 'Ресторан «Жюль Верн»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Ваш семейный ресторан.',
                'Интерьер напоминает дом зажиточного путешественника-сибарита. Изысканная английская классика, «приправленная» роскошью востока: красное дерево в отделке зала, мягкие диваны, тяжелые портьеры и медные лампы, резные статуи индийских богов и, конечно же, во всем декоре улавливается «дух странствий», присущий великому Жюль Верну. Сердце ресторана - кухня - представлена европейским меню и индийским. В первом есть, как классические блюда: салат «Цезарь», Карпаччо из телятины с сыром «Пармезан», так и фирменные, приготовленные по рецептам шеф-поваров из Германии и Франции. Гордость кухни это - блюда из тандура, которые индийский шеф-повар, щедро сдабривая имбирем, чили, кориандром, шафраном, готовит на углях либо тушит в пряных соусах.',
                'Принадлежность предприятия: СП «Санта Импекс Брест» ООО',
            ],
        },
        {
            id: 23,
            location: 'Брест',
            name: 'Бар «Санта» СП «Санта Импекс Брест»',
            adress: 'г. Брест, ул. Орджоникидзе, 7',
            countItem: 'Число мест: 40',
            timeWork: 'время работы - с 11-00 до 23-00',
            phones: [
                '(+375) 162 26-36-05',
            ],
            desc: [
                'Категория: первая. Присвоение категории: № 44 от 22.11.96 г.',
                'Эксклюзивный рыбный ресторан-бар «САНТА»',
                'Магическое притяжение создает оригинальная кухня, специализируящаяся на блюдах из рыбы и морских деликатесов, вобравших в себя лучшие традиции кулинарии народов мира. Лучшее эксклюзивное меню страны. Вашему ниманию представлена шикарная карта вин, коньяков и известных марок пива на любой вкус. Оригинальный интерьер выполнен в морском стиле. Атмосфера умиротворенности и комфорта, высокая культура обслуживания, рыбная кухня экстра класса - идеальные условия для серьезных деловых бесед и достойного досуга.',
                'Принадлежность предприятия: СП «Санта Импекс Брест» ООО',
            ],
        },
        {
            id: 24,
            location: 'Брест',
            name: 'Кафе «Трактир «У озера» СП «Санта Импекс Брест»',
            adress: 'г. Брест, парк Культуры и Отдыха',
            countItem: 'Число мест: 88',
            timeWork: 'время работы - с 12-00 до 23-30',
            phones: [
                '(+375) 162 26-53-67',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/uozer.jpg'),
                    alt: 'Кафе «Трактир «У озера»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Ресторан-бар старославянской кухни Трактир «У ОЗЕРА»',
                'Традиционно вкусно! Являясь архитектурным украшением города и парка, расположенный на берегу живописного озера, трактир представляет собой все лучшее из истории старославянского быта. Переступив порог, наши посетители забывают о повседневной суматохе и погружаются в атмосферу спокойствия, домашнего уюта и наслаждения вкусом. Кухня - это душа и главное достоинство трактира. Мы предлагаем уникальные блюда по самобытным рецептам из глубины веков: от крестьянского обеда до царского пира. К услугам посетителей три разнообразных зала и открытая площадка.',
                'Действует услуга «С Пылу - С Жару» драйв.',
                'Принадлежность предприятия: СП «Санта Импекс Брест» ООО',
            ],
        },
        {
            id: 25,
            location: 'Брест',
            name: 'Гриль-бар «САНТА» СП «Санта Импекс Брест»',
            adress: 'г. Брест, ул. Карбышева, 17',
            timeWork: 'время работы - с 10-00 до 22-00',
            phones: [
                '(+375) 162 23-49-23',
            ],
            desc: [
                'Присвоение категории:приказ УТ Брестского горисполкома',
                'Быстро, вкусно и кошельку не грустно!',
                'Работа организована по принципу «все и сразу». За несколько минут гости и жители города могут получить быстрое, вкусное, качественное питание и обслуживание, приобрести еду и напитки в дорогу или перекусить на оригинальной открытой площадке.',
                'Принадлежность предприятия: СП «Санта Импекс Брест» ООО',
            ],
        },
        {
            id: 26,
            location: 'Брест',
            name: 'Бар «Купалле»',
            adress: 'г. Брест, ул. Ленинградская, 37',
            countItem: 'Число мест: 25',
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: КУТПП «Беларусь»',
            ],
        },
        {
            id: 27,
            location: 'Брест',
            name: 'Кафе «Корчма «Охотничья»',
            adress: 'г. Брест, ул. Московская, 332/4',
            countItem: 'Число мест: 36',
            desc: [
                'Категория: первая. Присвоение категории: № 62 от 19.12.01 г.',
                'Принадлежность предприятия: ООО «Идея»',
            ],
        },
        {
            id: 28,
            location: 'Брест',
            name: 'Бар «Космик»',
            adress: 'г. Брест, ул. Советская, 73',
            countItem: 'Число мест: 50',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/kosmik.jpg'),
                    alt: 'Бар «Космик»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: Приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: СП «Бела Трейдинг Дьюти Фри» ООО',
            ],
        },
        {
            id: 29,
            location: 'Брест',
            name: 'Бар «Матрица»',
            adress: 'г. Брест, ул. Советская, 73',
            countItem: 'Число мест: 200',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/matrix.jpg'),
                    alt: 'Бар «Матрица»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: Приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: СП «Бела Трейдинг Дьюти Фри» ООО',
            ],
        },
        {
            id: 30,
            location: 'Брест',
            name: 'Бар ГП «Брестгрузавтосервис»',
            adress: 'г. Брест, ул. Л-та Рябцева, 45',
            countItem: 'Число мест: 27',
            desc: [
                'Категория: первая. Присвоение категории: № 30 от 13.07.2000',
                'Принадлежность предприятия: ГП «Брестгрузавтосервис»',
            ],
        },
        {
            id: 31,
            location: 'Брест',
            name: 'Кафе ГП «Брестгрузавтосервис»',
            adress: 'г. Брест, ул. Л-та Рябцева, 45',
            countItem: 'Число мест: 56',
            desc: [
                'Категория: первая. Присвоение категории: № 30 от 13.07.2000',
                'Принадлежность предприятия: ГП «Брестгрузавтосервис»',
            ],
        },
        {
            id: 32,
            location: 'Брест',
            name: 'Кафе «Магеллан» ИЧТП «Файв старс»',
            adress: 'г. Брест, г. Брест, ул. Комсомольская,36',
            countItem: 'Число мест: 55',
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: ИЧТП «Файв старс»',
            ],
        },
        {
            id: 33,
            location: 'Брест',
            name: 'Бар «Кравира и К»',
            adress: 'г. Брест, бульвар Шевченко, 4',
            countItem: 'Число мест: 36',
            desc: [
                'Категория: первая. Присвоение категории: Приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: ТПЧУП «Кравира и К»',
            ],
        },
        {
            id: 34,
            location: 'Брест',
            name: 'Кафе «Кравира и К»',
            adress: 'г. Брест, бульвар Шевченко, 4',
            countItem: 'Число мест: 240',
            desc: [
                'Категория: первая. Присвоение категории: №14 от 17.03.98г.',
                'Принадлежность предприятия: ТПЧУП «Кравира и К»',
            ],
        },
        {
            id: 35,
            location: 'Брест',
            name: 'Бар «Старый город» ЧУПТП «Белстрой»',
            adress: 'г. Брест, ул. Кирова, 103',
            countItem: 'Число мест: 38',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/star.jpg'),
                    alt: 'Бар «Старый город»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: ЧУПТП «Белстрой»',
            ],
        },
        {
            id: 36,
            location: 'Брест',
            name: 'Бар «Покер» в бильярдном клубе «Олимп»',
            adress: 'г. Брест, ул. Московская, 326',
            countItem: 'Число мест: 35',
            desc: [
                'Категория: первая. Присвоение категории: Заключение КПиТ от 13.05.2004',
                'Принадлежность предприятия: ООО «Покер»',
            ],
        },
        {
            id: 37,
            location: 'Брест',
            name: 'Бар «Покер»',
            adress: 'г. Брест, пр. Машерова, 15',
            countItem: 'Число мест: 25',
            desc: [
                'Категория: первая. Присвоение категории: Заключение КПиТ от 13.05.2004',
                'Принадлежность предприятия: ООО «Покер»',
            ],
        },
        {
            id: 38,
            location: 'Брест',
            name: 'Бар «Энигма»',
            adress: 'г. Брест, ул.Комсомольская, 34',
            countItem: 'Число мест: 25',
            desc: [
                'Категория: первая. Присвоение категории: № 20 от 25.04.01 г.',
                'Принадлежность предприятия: Индивидуальный предприниматель Касецкая О.В.',
            ],
        },
        {
            id: 39,
            location: 'Брест',
            name: 'Бар «Ассоль»',
            adress: 'г. Брест, м-н Южный ул. Жукова, 1',
            countItem: 'Число мест: 40',
            desc: [
                'Категория: первая. Присвоение категории: №65 от 30.12.99г.',
                'Принадлежность предприятия: Индивидуальный предприниматель Рощин В.И.',
            ],
        },
        {
            id: 40,
            location: 'Брест',
            name: 'Бар в боулинг клубе ЧУПТП «Константа-Брест»',
            adress: 'г. Брест, пр. Машерова, 96/1',
            countItem: 'Число мест: 112',
            desc: [
                'Категория: первая Присвоение категории:№ 57 от 19.11.01 г.',
                'Принадлежность предприятия: ЧУПТП «Константа-Брест»',
            ],
        },
        {
            id: 41,
            location: 'Брест',
            name: 'Ресторан «Евразия»',
            adress: 'г. Брест, Старые Задворцы, гостиница «Дружба»',
            countItem: 'Число мест: 100',
            desc: [
                'Присвоение категории:приказ УТ Брестского горисполкома',
                'Принадлежность предприятия: ОДО «Фактор Найт Клаб»',
            ],
        },
        {
            id: 42,
            location: 'Брест',
            name: 'Бар в гостинице «Дружба»',
            adress: 'г. Брест, Старые Задворцы, гостиница «Дружба»',
            countItem: 'Число мест: 25',
            desc: [
                'Присвоение категории:Заключение КПиТ от 13.05.2004',
                'Принадлежность предприятия: ОДО «Фактор Найт Клаб»',
            ],
        },
        {
            id: 43,
            location: 'Брестский район',
            name: 'Коктейль-холл ТЭУДП «Бресттурист»',
            adress: 'Брестский район, Турбаза «Белое озеро»',
            countItem: 'Число мест: 20',
            desc: [
                'Принадлежность предприятия: ТЭУДП «Бресттурист»',
            ],
        },
        {
            id: 44,
            location: 'Брестский район',
            name: 'Бар санатория «Берестье» ООО «БОСКП «Брестагроздравница»',
            adress: 'Брестский район, п.Берестье, в районе «Белого озера»',
            countItem: 'Число мест: 10',
            desc: [
                'Категория: первая. Присвоение категории:Распоряжение Брестского РИК',
                'Принадлежность предприятия: ООО «БОСКП «Брестагроздравница»',
            ],
        },
        {
            id: 45,
            location: 'Береза',
            name: 'Ресторан Березовского райпо',
            adress: 'г. Береза, ул. Ленина, 61',
            countItem: 'Число мест: 92',
            desc: [
                'Категория: первая. Присвоение категории: Постановление правления Брестского облпотребсоюза № 122 от 05.05.2004',
                'Принадлежность предприятия: Облпотребсоюз Березовское райпо',
            ],
        },
        {
            id: 46,
            location: 'Ганцевичи',
            name: 'Ресторан «Цна» Ганцевичского райпо',
            adress: 'г. Ганцевичи',
            countItem: 'Число мест: 114',
            desc: [
                'Категория: первая. Присвоение категории: Постановление правления Брестского облпотреб-союза № 122 от 05.05.2004',
                'Принадлежность предприятия: Облпотребсоюз Ганцевичское райпо',
            ],
        },
        {
            id: 47,
            location: 'Дрогичин',
            name: 'Ресторан «Ивушка» Дрогичинского райпо',
            adress: 'г. Дрогичин, ул.Ленина,114',
            countItem: 'Число мест: 160',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/drog.jpg'),
                    alt: 'Ресторан «Ивушка»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: Постановление правления Брестского облпотребсоюза № 122 от 05.05.2004',
                'Принадлежность предприятия: Облпотребсоюз Дрогичинское райпо',
            ],
        },
        {
            id: 48,
            location: 'Жабинка',
            name: 'Ресторан Жабинковского райпо',
            adress: 'г. Жабинка, ул.Кирова, 82',
            countItem: 'Число мест: 135',
            desc: [
                'Категория: первая. Присвоение категории: Постановление правления Брестского облпотребсоюза № 122 от 05.05.2004',
                'Принадлежность предприятия: Облпотребсоюз Жабинковское райпо',
            ],
        },
        {
            id: 49,
            location: 'Иваново',
            name: 'Ресторан «Полесский» Ивановского райпо',
            adress: 'г. Иваново, ул.Советская, 52',
            countItem: 'Число мест: 110',
            desc: [
                'Категория: первая. Присвоение категории: Постановление правления Брестского облпотребсоюза № 122 от 05.05.2004',
                'Принадлежность предприятия: Облпотребсоюз Ивановское райпо',
            ],
        },
        {
            id: 50,
            location: 'Ивановский район',
            name: 'Ресторан «Под липами» Ивановского райпо',
            adress: 'Ивановский район',
            countItem: 'Число мест: 88',
            desc: [
                'Категория: первая. Присвоение категории: Постановление правления Брестского облпотребсоюза № 122 от 05.05.2004',
                'Принадлежность предприятия: Облпотребсоюз Ивановское райпо',
            ],
        },
        {
            id: 51,
            location: 'Ивановский район',
            name: 'Коктейль-бар санатория «Алеся»',
            adress: 'Ивановский район, д.Завышье',
            countItem: 'Число мест: 10',
            desc: [
                'Категория: первая. Присвоение категории: Распоряжение ИвановскогоРИК',
                'Принадлежность предприятия: ООО «БОСКП «Брестагроздравница»',
            ],
        },
        {
            id: 52,
            location: 'Ивацевичи',
            name: 'Ресторан «Щара» Ивацевичского райпо',
            adress: 'г. Ивацевичи, ул.Комсомольская, 21',
            countItem: 'Число мест: 168',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/scara.jpg'),
                    alt: 'Ресторан «Щара»',
                }
            ],
            desc: [
                'Категория: первая',
                'Принадлежность предприятия: Облпотребсоюз Ивацевичское райпо',
            ],
        },
        {
            id: 53,
            location: 'Каменец',
            name: 'Ресторан «Белая вежа» Каменецкого райпо',
            adress: 'г. Каменец, ул.Брестская,36',
            countItem: 'Число мест: 150',
            desc: [
                'Категория: первая',
                'Принадлежность предприятия: Облпотребсоюз Каменецкое райпо',
            ],
        },
        {
            id: 54,
            location: 'Каменецкий район',
            name: 'Ресторан «У старой мельницы» Каменецкого райпо',
            adress: 'Каменецкий район',
            countItem: 'Число мест: 100',
            desc: [
                'Категория: первая',
                'Принадлежность предприятия: Облпотребсоюз Каменецкое райпо',
            ],
        },
        {
            id: 55,
            location: 'Каменецкий район',
            name: 'Ресторан «Беловежская пуща»',
            adress: 'Каменецкий район, д. Каменюки',
            countItem: 'Число мест: 180',
            desc: [
                'Категория: первая. Присвоение категории: №49 от 16.11.99г.',
                'В ресторане можно отведать национальные блюда, приготовленные из мяса дичи.',
                'Принадлежность предприятия: Государственный национальный парк «Беловежская пуща»',
            ],
        },
        {
            id: 56,
            location: 'Кобрин',
            name: 'Ресторан «Кобрин» ОАО«Кобрин-Сервис»',
            adress: 'г. Кобрин, ул.Ленина, 11',
            countItem: 'Число мест: 120',
            timeWork: 'Режим работы: по заявке клиентов; Пятница, суббота с 18.00 до 01.00',
            phones: [
                '(+375) 1642 2-31-39',
                '(+375) 1642 2-55-00',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/kobrin.jpg'),
                    alt: 'Ресторан «Кобрин»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: Распоряжение Кобринского райисполкома от 26.12.03. № 451',
                'Принадлежность предприятия: ОАО«Кобрин-Сервис»',
            ],
        },
        {
            id: 57,
            location: 'Кобрин',
            name: 'Кафе «Олимп» ОАО «Универмаг»',
            adress: '225306, г. Кобрин, ул. Дзержинского, 91',
            countItem: 'Число мест: 60',
            timeWork: 'Время работы: Понедельник, вторник, среда, четверг с 08.00 до 24.00. Пятница, суббота, воскресенье с 08.00 до 02.00',
            phones: [
                '(+375) 1642 2-14-82',
                '(+375) 1642 2-14-82',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/olimp1.jpg'),
                    alt: 'Кафе «Олимп»',
                }
            ],
            desc: [
                'Категория: первая. Присвоение категории: Распоряжение Кобринского райисполкома от 26.12.03. № 451',
                'Принадлежность предприятия: Открытое акционерное общество «УНИВЕРМАГ «КОБРИН».',
                'Открытое акционерное общество «Универмаг «Кобрин» основано в 2003 году на базе коммунального унитарного торгового предприятия «Универмаг «Кобрин», расположено по ул. Дзержинского,93 в г. Кобрине. Основным видом деятельности акционерного общества является торговля и общественное питание.',
                'В состав акционерного общества входит:',
                'Магазин «Универмаг» (1200 2 общей площади, ул. Ленина, 13 г.Кобрин) по продаже непродовольственных товаров.',
                'Магазин «Дом торговли» (2400 2 общей площади, ул. Дзержинского, 93 г. Кобрин) по продаже непродовольственных и продовольственных товаров.',
                'Кафе «Олимп» (500 м2 общей площади, ул. Дзержинского, 91 г.Кобрин) первая наценочная категория на 80 посадочных мест, кондитерский цех.',
            ],
        },
        {
            id: 58,
            location: 'Кобрин',
            name: 'Ресторан «Эдельвейс»',
            adress: '225306, г. Кобрин, ул. Дружбы, 2',
            timeWork: 'Режим работы: с 07.30 до 03.00',
            phones: [
                '(+375) 1642 3-90-97',
                'факс: (+375) 1642 3-90-96',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Bars/ed.jpg'),
                    alt: 'Ресторан «Эдельвейс»',
                }
            ],
        },
        {
            id: 59,
            location: 'Кобринский район',
            name: 'Бар СП «Кобвар»',
            adress: 'Кобринский район д. Петьки',
            countItem: 'Число мест: 20',
            timeWork: 'Режим работы: с 17.00 до 01.00. Выходной - понедельник',
            phones: [
                '(+375) 1642 2-84-54',
            ],
            desc: [
                'Категория: первая. Присвоение категории: №2 от 10.02.94 г.',
                'Принадлежность предприятия: СП «Кобвар»',
            ],
        },
        {
            id: 60,
            location: 'Лунинец',
            name: 'Ресторан «Припять» Лунинецкого райпо',
            adress: 'г. Лунинец, ул. Гагарина, 16',
            countItem: 'Число мест: 221',
            desc: [
                'Категория: первая',
                'Принадлежность предприятия: Облпотребсоюз Лунинецкое райпо',
            ],
        },
        {
            id: 61,
            location: 'Лунинец',
            name: 'Коктейль-бар комбината питания Лунинецкого райпо',
            adress: 'г. Лунинец, ул. Гагарина, 16',
            countItem: 'Число мест: 6',
            desc: [
                'Категория: первая',
                'Принадлежность предприятия: Облпотребсоюз Лунинецкое райпо',
            ],
        },
        {
            id: 62,
            location: 'Лунинец',
            name: 'Видео-бар комбината питания Лунинецкого райпо',
            adress: 'г. Лунинец, ул. Гагарина, 16',
            countItem: 'Число мест: 44',
            desc: [
                'Категория: первая',
                'Принадлежность предприятия: Облпотребсоюз Лунинецкое райпо',
            ],
        },
        {
            id: 63,
            location: 'Микашевичи',
            name: 'Бар г. Микашевичи ЗАО «Агропромсервис»',
            adress: 'Лунинецкий район, г. Микашевичи, ул. Ленинская, 3',
            countItem: 'Число мест: 30',
            desc: [
                'Категория: первая. Присвоение категории: №54 от 30.10.98г.',
                'Принадлежность предприятия: ЗАО «Агропромсервис»',
            ],
        },
        {
            id: 64,
            location: 'Ляховичи',
            name: 'Ресторан «Ласточка» Ляховичского райпо',
            adress: 'г. Ляховичи, ул.17 Сентября, 1',
            countItem: 'Число мест: 102',
            desc: [
                'Категория: первая',
                'Принадлежность предприятия: Облпотребсоюз Ляховичское райпо',
            ],
        },
        {
            id: 65,
            location: 'Малорита',
            name: 'Ресторан «Рита» Малоритского райпо',
            adress: 'г. Малорита, ул. Советская, 26',
            countItem: 'Число мест: 135',
            desc: [
                'Категория: первая',
                'Принадлежность предприятия: Облпотребсоюз Малоритское райпо',
            ],
        },
        {
            id: 66,
            location: 'Пинск',
            name: 'Ресторан «Припять» ОАО «Гостиничный комплекс «Припять»',
            adress: 'г. Пинск, ул. Днепровской флотилии, 31',
            countItem: 'Число мест: 160',
            desc: [
                'Категория: первая. Присвоение категории: №9 от 11.03.94г.',
                'Принадлежность предприятия: ОАО «Гостиничный комплекс «Припять»',
            ],
        },
        {
            id: 67,
            location: 'Пинск',
            name: 'Бар «Парус» ОАО «Гостиничный комплекс «Припять»',
            adress: 'г. Пинск, ул. Днепровской флотилии, 31',
            countItem: 'Число мест: 60',
            desc: [
                'Категория: первая. Присвоение категории: №9 от 11.03.94г.',
                'Принадлежность предприятия: ОАО «Гостиничный комплекс «Припять»',
            ],
        },
        {
            id: 68,
            location: 'Пинск',
            name: 'Ресторан «Нестерка» ОАО «Нестерка»',
            adress: 'г. Пинск, ул.Центральная, 82',
            desc: [
                'Категория: первая. Присвоение категории: №25 от 11.07.97г.',
                'Принадлежность предприятия: ОАО «Нестерка»',
            ],
        },
        {
            id: 69,
            location: 'Пинск',
            name: 'Бар «Спутник» ОАО «Надзея-Пинск»',
            adress: 'г. Пинск, ул.Ленина, 6',
            desc: [
                'Категория: перваяю Присвоение категории: №37 от 12.09.97г.',
                'Принадлежность предприятия: ОАО «Надзея-Пинск»',
            ],
        },
        {
            id: 70,
            location: 'Пинск',
            name: 'Ресторан «Аэлита» ООО»Славянка»',
            adress: 'г. Пинск, ул. Железнодорожная',
            desc: [
                'Категория: первая. Присвоение категории: №53 от 7.12.94г.',
                'Принадлежность предприятия: ООО»Славянка»',
            ],
        },
        {
            id: 71,
            location: 'Пинск',
            name: 'Бар «Аэлита» ООО «Вест и К»',
            adress: 'г. Пинск, ул. Железнодорожная ',
            desc: [
                'Категория: первая. Присвоение категории: №53 от 7.12.94г.',
                'Принадлежность предприятия: ООО «Вест и К»',
            ],
        },
        {
            id: 72,
            location: 'Пружаны',
            name: 'Ресторан Пружанского райпо',
            adress: 'г. Пружаны, ул. Советская, 17',
            countItem: 'Число мест: 104',
            desc: [
                'Категория: первая.',
                'Принадлежность предприятия: Облпотребсоюз Пружанское райпо',
            ],
        },
    ];

    let get_all_list = (data) => {
        return (
            <ul>
                {data?.map((h) => {
                    const link = "/reference-information-bars/" + h.id;
                    return (<li><a href={link}>{h.location}. {h.name}</a></li>)
                })}

            </ul>
        );
    }

    let get_item = (data) => {
        let result = null;

        if (data.name != undefined) {
            title = data.name;
        }

        let gal = [];
        if (data.gal != undefined) {
            data.gal.map(item => {
                gal.push({
                    original: item.src,
                    thumbnail: item.src,
                    description: item.alt,
                });
            });
        }

        return (
            <>
                {data.adress != undefined && <p>{data.adress}</p>}
                {data.countItem != undefined && <p>{data.countItem}</p>}
                {data.phones != undefined && <ul>{data.phones.map(p => <li>{p}</li>)}</ul>}
                {data.url != undefined && <a href={data.url}>{data.url}</a>}
                {gal?.length > 0 &&
                    <div className="two-col-cell">
                        <ImageGallery
                            items={gal}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                }
                {data.timeWork != undefined && <p>{data.timeWork}</p>}
                {data?.desc?.length > 0 &&
                    data.desc.map(d => <p>{d}</p>)
                }
                {data?.imgs?.length > 0 &&
                    data.imgs.map(i => <img src={i}/>)
                }
            </>
        );
    }

    const params = useParams();

    let view = undefined;
    let nav = get_all_list(itemsData);
    if (params.id != undefined) {
        const id = itemsData.findIndex(e => e.id == params.id);
        if (id == -1) {
            view = get_all_list(itemsData);
        } else {
            view = get_item(itemsData[id]);
        }
    }

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {view}
                </div>
                <div className="pageitem">
                    <hr/>
                    {nav}
                </div>
            </div>
        </>
    );
}